import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { ErrorModal } from '../ErrorModal/ErrorModal';
import { INSTALLER_ERRORS } from '../../errors';
import { ModalWrapper } from '../ModalRenderer/ModalWrapper';
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "handleError", void 0);
    this.state = {
      hasError: false
    };
    this.handleError = props.handleError;
  }
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  componentDidCatch(e) {
    this.handleError({
      error: e,
      ...INSTALLER_ERRORS.GENERIC
    });
  }
  render() {
    if (this.state.hasError) {
      return /*#__PURE__*/React.createElement(ModalWrapper, null, /*#__PURE__*/React.createElement(ErrorModal, null));
    }
    return this.props.children;
  }
}
//# sourceMappingURL=ErrorBoundary.js.map